// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__18gtl","col":"styles_col__1uiey"};